<template>
    <el-card shadow="never" class="aui-card--fill">
        <el-row style="background-color: #F3F4F4;">
            <el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
                <img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />人员报送
            </el-col>
            <el-col :xs="24" :md="18">
                <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
                    <el-form-item>
                        <el-button class="uploadBtn" type="primary" @click="uploadResultHandle">上传报送结果</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="exportBtn" type="default" @click="downloadHandle">下载人员报送表</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>

        <div class="mod-declare__personnel">
            <el-row style="border-bottom: 3px solid #F3F4F4;padding-bottom: 10px;">
                <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="报送状态">
                        <el-select v-model="dataForm.submitStatus" placeholder="请选择" clearable>
                            <el-option label="未报送" :value="0"></el-option>
                            <el-option label="已报送" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="创建时间">
                        <el-date-picker
                            v-model="createTimeRange"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            @change="createTimeChange">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="灵活用工平台名称">
                        <el-select v-model="dataForm.bodyId" placeholder="请选择" clearable>
                            <el-option
                                v-for="item in bodyPageList"
                                :key="item.id"
                                :label="`${item.bodyName}-${item.abbreviation}`"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="灵工姓名">
                        <el-input v-model="dataForm.realName" placeholder="灵工姓名" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="授权认证签约状态">
                        <el-select v-model="dataForm.authSignStatus" placeholder="请选择" clearable>
                            <el-option label="待签约" value="0"></el-option>
                            <el-option label="已签约" value="1"></el-option>
                            <el-option label="签约中" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="报送方式">
                        <el-select v-model="dataForm.submitType" placeholder="请选择" clearable>
                            <el-option label="线上报送" value="online"></el-option>
                            <el-option label="线下报送" value="offline"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item style="margin-top: 20px;margin-left: 20px;" label="注册电签状态">
                        <el-select v-model="dataForm.registerStatus" placeholder="请选择" clearable>
                            <el-option label="待注册" value="0"></el-option>
                            <el-option label="注册中" value="1"></el-option>
                            <el-option label="注册成功" value="2"></el-option>
                            <el-option label="注册失败" value="3"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="身份证号码">
                        <el-input v-model="dataForm.idCard" placeholder="身份证号码" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;">
                        <el-button type="primary" @click="getDataList()">查询</el-button>
                        <el-button type="default" @click="resetForm">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-row>

            <div class="table-container">
                <el-table
                    v-loading="dataListLoading"
                    :data="dataList"
                    @selection-change="dataListSelectionChangeHandle"
                    @sort-change="dataListSortChangeHandle"
                    style="width: 100%;"
                    height="100%">
                <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
                <el-table-column prop="realName" label="姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="idCard" label="身份证号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="realNameAuthStatus" label="实名认证状态" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.realNameAuthStatus === 0" size="small" type="info">未认证</el-tag>
                        <el-tag v-else-if="scope.row.realNameAuthStatus === 1" size="small" type="success">已认证</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="idCardAuthStatus" label="证件照认证状态" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.idCardAuthStatus === 0" size="small" type="info">未认证</el-tag>
                        <el-tag v-else-if="scope.row.idCardAuthStatus === 1" size="small" type="success">已认证</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="videoAuthStatus" label="视频认证状态" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.videoAuthStatus === 0" size="small" type="info">未认证</el-tag>
                        <el-tag v-else-if="scope.row.videoAuthStatus === 1" size="small" type="success">已认证</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="eSignStatus" label="注册电签状态" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.eSignStatus === 0" size="small" type="info">未注册</el-tag>
                        <el-tag v-else-if="scope.row.eSignStatus === 1" size="small" type="warning">已注册</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="registerDesc" label="注册说明" header-align="center" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="platformName" label="灵活用工平台名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="submitType" label="报送方式" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.submitType === 'online'" size="small" type="primary">线上报送</el-tag>
                        <el-tag v-else size="small" type="warning">线下报送</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="authSignStatus" label="授权认证签约状态" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.authSignStatus === 0" size="small" type="info">待签约</el-tag>
                        <el-tag v-else-if="scope.row.authSignStatus === 1" size="small" type="warning">已签约</el-tag>
                        <el-tag v-else-if="scope.row.authSignStatus === 2" size="small" type="warning">签约中</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="bizSignStatus" label="业务合作签约状态" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.bizSignStatus === 0" size="small" type="info">待签约</el-tag>
                        <el-tag v-else-if="scope.row.bizSignStatus === 1" size="small" type="warning">已签约</el-tag>
                        <el-tag v-else-if="scope.row.bizSignStatus === 2" size="small" type="warning">签约中</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="submitType" label="报送方式" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.submitType === 0" size="small" type="info">线上报送</el-tag>
                        <el-tag v-else-if="scope.row.submitType === 1" size="small" type="success">线下报送</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="submitStatus" label="报送状态" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.submitStatus === 0" size="small" type="info">未报送</el-tag>
                        <el-tag v-else-if="scope.row.submitStatus === 1" size="small" type="success">已报送</el-tag>
                        <!-- <el-tag v-else-if="scope.row.submitStatus === 2" size="small" type="danger">报送失败</el-tag> -->
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column> -->
                <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
                <!-- <el-table-column label="操作" fixed="right" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row.id)">查看</el-button>
                        <el-button type="text" size="small" @click="editHandle(scope.row.id)">编辑</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            </div>

            <el-pagination
                background
                :current-page="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="pageSizeChangeHandle"
                @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>

        <el-dialog title="上传人员基本信息报送结果" :visible.sync="uploadDialogVisible" width="500px" :before-close="handleCloseUploadDialog">
            <div class="upload-dialog-content">
                <el-form>
                    <el-form-item label="下载模版">
                        <el-button type="primary" @click="downloadTemplate">下载模版</el-button>
                    </el-form-item>
                    <el-form-item label="互联网平台企业名称">
                        <el-select v-model="bodyId" placeholder="请选择" clearable>
                            <el-option
                                v-for="item in bodyPageList"
                                :key="item.id"
                                :label="`${item.bodyName}-${item.abbreviation}`"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上传申报结果表">
                        <el-upload
                            ref="upload"
                            action=""
                            accept=".xlsx,.xls"
                            :on-change="handleFileChange"
                            :http-request="fileUpload"
                            :multiple="false"
                            :file-list="fileList"
                            :auto-upload="false"
                            :limit="1">
                            <el-button slot="trigger" size="small" type="default">选取文件</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传 Excel 文件</div>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseUploadDialog">取 消</el-button>
                <el-button type="primary" @click="confirmUpload">确 定</el-button>
            </span>
        </el-dialog>
    </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import { addDynamicRoute } from '@/router'
import Cookies from 'js-cookie'
import qs from 'qs'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      uploadDialogVisible: false,
      fileList: [],
      mixinViewModuleOptions: {
        isBodyPage: true,
        createdIsNeed: true,
        getDataListURL: '/sys/plat/tax/person/submit/page',
        getDataListIsPage: true,
        exportURL: '/declare/personnel/export'
      },
        createTimeRange: [],
        bodyId:'',
      dataForm: {
        submitStatus: null,
        startDate: '',
        endDate: '',
        bodyId: '',
        realName: '',
        authSignStatus: '',
        submitType: '',
        registerStatus: '',
        idCard: ''
      }
    }
  },
  methods: {
    createTimeChange (val) {
      if (val && val.length === 2) {
        this.dataForm.startDate = val[0]
        this.dataForm.endDate = val[1]
      } else {
        this.dataForm.startDate = ''
        this.dataForm.endDate = ''
      }
    },
    resetForm () {
      this.dataForm = {
        submitStatus: null,
        startDate: '',
        endDate: '',
        bodyId: '',
        realName: '',
        authSignStatus: '',
        submitType: '',
        registerStatus: '',
        idCard: ''
      }
      this.createTimeRange = []
      this.getDataList()
    },
    uploadResultHandle () {
      this.uploadDialogVisible = true
      this.fileList = []
    },
    handleCloseUploadDialog () {
      this.uploadDialogVisible = false
      this.fileList = []
    },
    downloadTemplate () {
      const token = Cookies.get('access_token')
      window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/tax/person/submit/template?access_token=${token}`)
    },
    handleFileChange (file, fileList) {
      this.fileList = fileList.slice(-1)
    },
    fileUpload (param) {
      const formData = new FormData()
      formData.append('file', param.file)
      
      this.$http.post('/sys/plat/tax/person/submit/update-submit-status', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('上传成功')
        this.uploadDialogVisible = false
        this.fileList = []
        this.getDataList()
      }).catch(() => {
        this.$message.error('上传失败')
      })
    },
    confirmUpload () {
      if (this.fileList.length === 0) {
        return this.$message.warning('请选择要上传的文件')
      }
      this.$refs.upload.submit()
    },
    downloadHandle () {
      const params = qs.stringify({
        'access_token': Cookies.get('access_token'),
        ...this.dataForm
      })
      window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/tax/person/submit/export?${params}`)
    },
    // resubmitHandle () {
    //   if (this.dataListSelections.length === 0) {
    //     return this.$message.warning('请选择需要重新报送的数据')
    //   }
    //   this.$confirm('确认要重新报送选中的数据吗？', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.$http.post('/declare/personnel/resubmit', {
    //       ids: this.dataListSelections.map(item => item.id)
    //     }).then(({ data: res }) => {
    //       if (res.code !== 0) {
    //         return this.$message.error(res.msg)
    //       }
    //       this.$message.success('重新报送成功')
    //       this.getDataList()
    //     }).catch(() => {})
    //   }).catch(() => {})
    // },
  //   viewHandle (id) {
  //     localStorage.setItem(this.$route.name, JSON.stringify(this.dataForm))
  //     const routeParams = {
  //       routeName: `${this.$route.name}__查看详情`,
  //       title: '人员报送详情',
  //       path: 'declare/personnel-detail',
  //       params: {
  //         id: id
  //       }
  //     }
  //     addDynamicRoute(routeParams, this.$router)
  //   },
  //   editHandle (id) {
  //     localStorage.setItem(this.$route.name, JSON.stringify(this.dataForm))
  //     const routeParams = {
  //       routeName: `${this.$route.name}__编辑`,
  //       title: '编辑人员报送',
  //       path: 'declare/personnel-edit',
  //       params: {
  //         id: id
  //       }
  //     }
  //     addDynamicRoute(routeParams, this.$router)
  //   }
  }
}
</script>

<style lang="scss" scoped>
.mod-declare__personnel {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 190px);
  
  .el-row {
    flex-shrink: 0;
  }
  
  .table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 20px;

    .el-table {
      flex: 1;
      overflow: hidden;
    }
  }
  
  .el-pagination {
    flex-shrink: 0;
    margin-top: 20px;
    text-align: right;
  }
}

/deep/ .el-table {
  .el-table__header-wrapper {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #f5f7fa;
  }

  .el-table__fixed-header-wrapper {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #f5f7fa;
  }
}
</style>